import React, { useContext } from 'react';
import { FlowContext } from '../../core/flow-engine';
import { rolloverTypes } from '../../flows/shared/utils';
import {
  MFBeaconButton,
  MFBeaconIconButton,
  MFBeaconModal
} from '../Beacon/BeaconComponents';
import { modalCloseHandler } from '../Modal/utils';
import closeBtn from '../../assets/images/Icon-button-close-beacon.svg';
import styles from './styles.css';

const modalTitle = 'One of your funds is closed to indirect rollovers';

const getClosedFunds = closedTickers => {
  const desc =
    'One or more of the funds you selected is only available to direct rollover accounts:';
  const closedFunds = closedTickers.map(f => {
    return `${f.name} (${f.ticker})`;
  });
  return `${desc} ${closedFunds}`;
};

const ClosedFundsModalWithRouting = () => {
  const { appState, next } = useContext(FlowContext);
  const {
    store: {
      loadedData: { closedTickers }
    }
  } = appState;

  return (
    <>
      <MFBeaconModal open removeCloseButton>
        <span className="modal-close-icon">
          <MFBeaconIconButton
            id="closedFundsRoutingModalCloseIcon"
            variant="tertiary"
            onClick={() => {
              modalCloseHandler();
              next('BYOP')();
            }}
            label="close-button">
            <img slot="icon" src={closeBtn} alt="close icon" />
          </MFBeaconIconButton>
        </span>
        <div className="beacon-modal__title">{modalTitle}</div>
        <div id="test" className="beacon-modal__description">
          {getClosedFunds(closedTickers)}
        </div>
        <div
          slot="action-zone"
          className="closed-funds-routing-modal-btn-container">
          <MFBeaconButton
            noButtonMargin
            variant="tertiary"
            id="closedFundsRemoveFunds"
            data-name="closedFundsRemoveFunds"
            type="button"
            onClick={() => {
              modalCloseHandler();
              next('BYOP')();
            }}
            label="Remove Fund(s)"
          />
          <MFBeaconButton
            noButtonMargin
            type="button"
            id="changeToDirectRollover"
            data-name="changeToDirectRollover"
            variant="primary"
            onClick={() => {
              modalCloseHandler();
              next(rolloverTypes.DIRECT)();
            }}
            label="Change To Direct Rollover"
          />
        </div>
      </MFBeaconModal>
      <style jsx>{styles}</style>
    </>
  );
};

export default ClosedFundsModalWithRouting;
